export default __webpack_public_path__ + "static/identity-mock-m7-ed2c9e6218024be458d755e45963d810.png";